<template>

    <div>
        <div class="no-background mt-24">
            <div class="">

                <!--div class="btn-hide-mobile mt-24"></div-->

                <!-- NOT FOR MOBILE  - START -->
                <!-- Caminho -->
                <!--div class="row btn-hide">
                    <div class="col-12">
                        <a class="a-link sm">O meu SAMS Quadros</a>
                        <i class="fas fa-chevron-right active-color ml-1" style="color: #5062aa;"></i>
                        <a class="a-link sm">Acordos - Rede Escolha Informada</a>
                        <i class="fas fa-chevron-right active-color ml-1" style="color: #5062aa;"></i>
                        <a class="custom-p sm ml-1">C.M.P. Consultório Médico - Cirurgico da Palmeira, Ldª.</a>
                    </div>
                </div-->
                <!-- NOT FOR MOBILE  - END -->

                <div class="btn-hide mt-56"></div>
                <div class="btn-hide-mobile mt-32"></div>

                <!-- Titulo -->
                <div class="row">
                    <div class="col-12 text-center text">
                        <h1 class="custom-h1 primary-color"><b>Detalhe do Acordo</b>
                        </h1>
                        <!--
                        <div class="mt-16">
                            <h4 class="custom-h4 orange-color mt-16 text-center">{{ resultado.cartaoFamilia ? 'Plano Saúde SNQTB' : 'sams quadros' }}</h4>
                        </div>
                        -->
                    </div>
                </div>
            </div>
        </div>
        <div v-if="!loadComplete" class="d-flex justify-content-center">
          <div class="spinner-border" role="status">
            <span class="sr-only">A carregar...</span>
          </div>
        </div>

        <div class="background primary-color mt-56" v-if="loadComplete === true">
            <div class="container">
                <div class="row">
                    <div class="col-lg-8 offset-lg-2">
                        <div class="row">
                            <div class="col-lg-8">
                              <img v-if="loggedUser" :src="'assets/images/' + (resultado.favorite ? 'favorite.png' : 'not_favorite.png')" style="cursor:pointer; padding-top:5px" width="24px" align="left" class="mr-1" v-on:click="changeFavoriteStatusValue"/>
                              <h1 class="custom-h2-title primary-color">
                                  {{ resultado.nomeComercial !== null  && resultado.nomeComercial !== '' ? resultado.nomeComercial : resultado.entidade }}  <br>
                                    {{ resultado.tituloMedico }} {{ resultado.nomeMedico }}
                                </h1>
                            </div>
                            <div class="col-lg-4">
                                <div class="d-flex justify-content-center">
                                    <div style="width: 65px;" class="text-center">
                                        <img src="assets/images/gray_shield.png" class="icons" :class="{'pl-2' : !resultado.cartaoFamilia}"/>
                                        <br/>
                                        <span class="text" >SNQTB Saúde</span>
                                    </div>
                                    <div v-if="resultado.cartaoFamilia" style="width: 65px;" class="text-center ml-3">
                                        <img src="assets/images/gray_heart.png" class="icons" style="margin-bottom: 3px;"/>
                                        <br/>
                                        <span class="text">Plano Saúde SNQTB</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-lg-6 mt-40">
                                <div class="contactos">
                                    <p class="custom-p block sm primary-color">
                                        <img src="assets/images/orange_location.png">
                                        {{ resultado.morada }} <br/>
                                        {{ resultado.cp4 }}-{{ resultado.cp3 }} {{ resultado.localidade }}
                                    </p>

                                    <div class="mt-24 d-block d-lg-none">
                                        <a class="text-decoration-none" target="_new" :href="'https://www.google.com/maps?saddr=' + userCurrentLocation + '&daddr=' + resultado.morada + ' ' + resultado.cp4 + '-' + resultado.cp3 + ' ' + resultado.localidade">
                                            <span class="custom-h6 orange-direct">Ver direcções </span>
                                            <img src="assets/images/orange_arrow.png" />
                                        </a>

                                    </div>

                                    <p  v-show="resultado.telefone !== null && resultado.telefone !== ''" class="custom-p block sm primary-color mt-32">
                                        <img src="assets/images/orange_phone.png" class="mr-1" />
                                        {{ resultado.telefone === null ? "&nbsp;" : resultado.telefone }}
                                    </p>
                                    <p  v-show="resultado.email !== null && resultado.email !== ''" class="custom-p block sm primary-color mt-32">
                                        <img src="assets/images/orange_mail.png" class="mr-1" />
                                        {{ resultado.email === null ? "&nbsp;" : resultado.email }}
                                    </p>
                                    <p  v-show="resultado.www !== null && resultado.www !== ''" class="custom-p block sm primary-color mt-32">
                                        <img src="assets/images/orange_link.png" class="mr-1" />
                                        {{ resultado.www === null ? "&nbsp;" : resultado.www }}
                                    </p>
                                </div>
                            </div>
                            <div class="col-lg-6 mt-40 d-none d-lg-block">
                                <a class="text-decoration-none" target="_new"
                                   :href="'https://www.google.com/maps/dir/?api=1&origin=' + userCurrentLocation + '&destination=' + encodedMorada">
                                    <span class="custom-h6 orange-direct">Ver direcções </span>
                                    <img src="assets/images/orange_arrow.png" />
                                </a>
                            </div>
                        </div>

                    </div>


                </div>
            </div>
        </div>

        <div class="mt-32" v-if="loadComplete">
            <div class="container">
                <div class="row">
                    <div class="col-lg-8 offset-lg-2">
                        <h6 class="custom-h6 primary-color">especialidades</h6>
                        <div class="mt-16 custom-input-dropdown dropdown w-100">
                            <a class="label" role="button" data-toggle="dropdown" aria-haspopup="true"
                               aria-expanded="false">
                                {{ especialidade === null ? 'Todas as especialidades' : especialidade }} <i
                                    class="fas fa-angle-down"></i>
                            </a>
                            <div class="dropdown-menu" aria-labelledby="dropdownMenuLink1">
                                <a class="custom-p block sm secondary-color mt-8"
                                   v-on:click="especialidade = null">Todas as especialidades
                                </a>
                                <a class="custom-p block sm secondary-color mt-8" v-for="esp in especialidades"
                                   v-on:click="especialidade = esp.especialidade">{{ esp.especialidade }}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="no-background mt-96" v-if="loadComplete === true">
            <div class="container">
                <div class="row">
                    <div class="col-lg-8 offset-lg-2">
                        <h3 class="custom-h3 primary-color">Atos médicos disponíveis nesta Entidade</h3>

                        <template v-for="especialidade in resultado.especialidades">
                            <div class="mt-32">
                                <h5 class="custom-h5 secondary-color">{{ especialidade.especialidade }}</h5>

                                <template v-for="descricaoPagamento in especialidade.descricaoPagamentos">
                                    <p class="custom-p sm mt-8">{{ descricaoPagamento.pagamento }}</p>
                                </template>
                                <hr class="special-line-no-margin mt-16" />
                            </div>
                        </template>


                        <template v-if="resultado.especialidades.length > 0 && resultado.especialidades.length < resultado.total">
                            <a class="custom-btn-secondary inline mt-40" v-on:click="currentPageView = currentPageView + 1">CARREGAR MAIS 10 RESULTADOS </a>
                        </template>

                        <router-link v-if="origin === 'search'" class="custom-btn-secondary inline mt-40 not-solo text-decoration-none" style="margin-bottom: 8px" :to="{name: 'Search'}">Voltar à Lista</router-link>
                        <router-link v-else class="custom-btn-secondary inline mt-40 not-solo text-decoration-none" style="margin-bottom: 8px" :to="{name: 'AcordosFavoritos'}">Voltar à Lista</router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex';

    export default {
      name: 'HospitalMedico',
      props: ['origin'],
      components: {},
      data() {
          return {
              name: 'hospitalMedico',
              loadComplete: false,
              resultado: null,
              hoverSams: false,
              hoverFamilia: false,
              currentPageView: 1,

              especialidades: [],
              especialidade: null,
          };
      },
      created() {
          this.currentPageView = 1;
          this.setCurrentPage(this.name);
          this.loadHospital();
          this.loadAllEspecialidades();
          let tmpEsp = this.$route.params.filtroEsp;
          if (tmpEsp) {
              this.especialidade = tmpEsp;
          }
      },
      watch: {
          '$route.params.id': function(id) {
              this.currentPageView = 1;
              this.loadComplete = false;
              this.resultado = null;
              let tmpEsp = this.$route.params.filtroEsp;
              if (tmpEsp) {
                this.especialidade = tmpEsp;
              } else {
                this.especialidade = null;
              }
              this.loadHospital();
          },
          '$route.params.medico': function(id) {
              this.currentPageView = 1;
              this.loadComplete = false;
              let tmpEsp = this.$route.params.filtroEsp;
              if (tmpEsp) {
                this.especialidade = tmpEsp;
              } else {
                this.especialidade = null;
              }
              this.loadHospital();
          },
          'currentPageView': function (val) {
            if (val > 1) {
              this.loadHospitalEspecialidades();
            }
          },
          'especialidade': function (val) {
              this.currentPageView = 1;
              this.loadHospitalEspecialidades();
          },
        },
        computed: {
          ...mapGetters('dirpesquisador',
              {
                currentPage: 'getCurrentPage',
                userCurrentLocation: 'getUserCurrentLocation',
                loggedUser: 'getLoggedUser',
                loggedToken: 'getLoggedToken'
              },
          ),
          encodedMorada() {
              const searchResult = this.resultado;
              return encodeURI(searchResult.morada + ' ' + searchResult.cp4 + '-' + searchResult.cp3 + ' ' + searchResult.localidade);
          },
        },
        methods: {
            ...mapActions('dirpesquisador',
                {
                    setCurrentPage: 'setCurrentPage',
                    loadHospitalItem: 'loadHospitalItem',
                    loadEspecialidades: 'loadEspecialidades',
                    scrollFrameTop: 'scrollFrameTop',
                    changeFavoriteStatus: 'changeFavoriteStatus',
                },
            ),
          loadHospital() {
            if (this.$route.params.id !== undefined) {
              const self = this;
              self.scrollFrameTop();
              this.loadHospitalItem(
                  {
                    idExterno: this.$route.params.id,
                    medico: this.$route.params.medico,
                    currentPageView: this.currentPageView,
                    especialidade: this.especialidade,
                    user: this.loggedUser,
                    token: this.loggedToken,
                  },
              )
                  .then((response) => {
                    console.log(response);
                    console.log('Elapse time: -> ' + response.loggingTime);
                    self.loadComplete = true;
                    self.resultado = response;
                    self.scrollFrameTop();
                  })
                  .catch((error) => {
                    console.log('Error loading platform configs!');
                    self.loadComplete = true;
                  });
            }
          },
          loadHospitalEspecialidades() {
            const self = this;

            this.loadHospitalItem(
                {
                  idExterno: this.$route.params.id,
                  medico: this.$route.params.medico,
                  currentPageView: this.currentPageView,
                  especialidade: this.especialidade,
                  user: this.loggedUser,
                  token: this.loggedToken,
                },
            )
                .then((response) => {
                  console.log('Elapse time: -> '  + response.loggingTime + ' ' + response.total);
                  self.loadComplete = true;
                  self.resultado.especialidades = self.resultado.especialidades.concat(response.especialidades);
                  self.resultado.total = response.total;
                })
                .catch((error) => {
                  console.log('Error loading platform configs!');
                  self.loadComplete = true;
                });
          },
          changeFavoriteStatusValue() {
            const self = this;
            parent.postMessage('loadinghide','*');
            this.changeFavoriteStatus(
                {
                  idAcordoMorada: this.resultado.idAcordoMorada,
                  idMedico: this.resultado.idmedico,
                  favorito: !this.resultado.favorite,
                  user: this.loggedUser,
                  token: this.loggedToken,
                },
            )
                .then((response) => {
                  if (response)
                    self.resultado.favorite = !self.resultado.favorite;
                  parent.postMessage('loadinghide','*');
                })
                .catch(() => {
                  console.log('Error changeFavoriteStatus!');
                  parent.postMessage('loadinghide','*');
                });
          },
            loadAllEspecialidades() {
                let self = this
                this.loadEspecialidades()
                    .then((response) => {
                        // console.log(response)
                        self.especialidades = response.especialidades
                    })
                    .catch((error) => {
                        console.error('Error loading especialidades!', error);
                    })
            },
        },
    };
</script>
